import { render } from "./EditTabletFormComponent.vue?vue&type=template&id=1162a8b5"
import script from "./EditTabletFormComponent.vue?vue&type=script&lang=js"
export * from "./EditTabletFormComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__